import { render, staticRenderFns } from "./CenaView.vue?vue&type=template&id=28b8c536&scoped=true"
import script from "./CenaView.vue?vue&type=script&lang=js"
export * from "./CenaView.vue?vue&type=script&lang=js"
import style0 from "./CenaView.vue?vue&type=style&index=0&id=28b8c536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8c536",
  null
  
)

export default component.exports